var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"accept-charset":"UTF-8"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._t("default"),_vm._v(" "),_c('spinner-lock',{attrs:{"is-locked":_vm.isLocked}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }